import {
  SOURCE_TYPES,
} from '@/store/MonitoringFeature/monitoringfeature'

export const ALIAS_TYPES = {
  alias: {
    text: 'Regular alias',
    value: 'alias',
  },
  qaqcAlias: {
    text: 'QA/QC alias',
    value: 'qaqcAlias',
  },
  depthHeightAlias: {
    text: 'Depth/Height alias',
    value: 'depthHeightAlias',
  },
}

export function getSynonymNames(sourceType, station) {
  switch (sourceType) {
  case SOURCE_TYPES.discreteEnvirodata: {
    return station.Synonyms
        .map(synonym => synonym.Name)
  }
  case SOURCE_TYPES.continuousAquarius: {
    return station.Synonyms
        .map(synonym => synonym.Name)
  }
  case SOURCE_TYPES.vegetativeMonitoringEnvirodata: {
    return station.Synonyms
        .map(synonym => synonym.Name)
  }
  case SOURCE_TYPES.surveysEnvirodata: {
    return station.Synonyms
        .map(synonym => synonym.Name)
  }
  default:
    throw 'getSynonymNames does not support this source type'
  }
}

export function hasNonPrimarySynonyms(sourceType, station) {
  return getSynonymNames(sourceType, station).length > 1
}